import PosCartActions from '../../../actions/PosCartActions';

class RemoveAll extends React.Component {

    constructor(props) {
        super(props);

        this.removeAll = this.removeAll.bind(this);
        this.isItemInCart = this.isItemInCart.bind(this);
    }

    removeAll() {
        var item = this.isItemInCart();

        if (!item)
            return;

        PosCartActions.removeItemFromCart(this.props.item, this.props.guest, item.QtyAllocated, true);
    }

    isItemInCart() {
        var item    = this.props.item;
        var cart    = this.props.cart;

        if (!cart)
            return false;

        for (var i=0; i<cart.length; i++) {
            if (cart[i].SerialNo === item.SerialNo)
                return cart[i];
        }

        return false;
    }

    render() {
        var item        = this.props.item;
        var cart        = this.props.cart;
        var guest       = this.props.guest;
        var className   = !this.isItemInCart() ? 'remove-all__disabled' : '';

        if (guest.IsPaid)
            return null;

        return (
            <div
                className='cart-item__options--remove-all btn-red'
                onClick={this.removeAll}>

                REMOVE ALL
            </div>

        );
    }
}

export default RemoveAll;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/selected/RemoveAll.react.jsx